import React, {Component} from 'react';

import Titulo from '../../components/Texto/Titulo';
import {TextoDados} from '../../components/Texto/Dados';
import InputSelect from '../../components/Inputs/Select';
import BlocoImagens from '../../components/Imagens/Bloco';
import Voltar from '../../components/Links/Voltar';

import {connect} from 'react-redux';
import * as actions from '../../actions/produtos';
import AlertGeral from '../../components/Alert/Geral';
import SearchCategories from '../../components/Search/Categories';
import ButtonToolbar from '../../components/Button/Toolbar';

import InputSimples from '../../components/Inputs/Simples';
import TextAreaSimple from '../../components/Inputs/TextAreaSimple';
import {formatMoney, formatMoneyOnChange} from '../../utils';
import erpApi from '../../services/erpApi';

class DetalhesDoProduto extends Component {

    generateStateProduto = (props) => ({
        nome: props.produto ? props.produto.titulo : "",
        disponibilidade: props.produto ? (props.produto.disponibilidade ? "disponivel" : "indisponivel") : "",
        quantidade: props.produto ? props.produto.quantidade : "",
        descricao: props.produto ? props.produto.descricao : "",
        categoria: props.produto ? props.produto.categoria : "",
        fotos: props.produto ? props.produto.fotos : "",
        preco: props.produto ? formatMoney(props.produto.preco) : "",
        promocao: props.produto ? formatMoney(props.produto.promocao) : "",
        sku: props.produto ? props.produto.sku : "",
        erpId: props.produto ? props.produto.erpId : ""
    });

    constructor(props) {
        super();
        this.state = {
            ...this.generateStateProduto(props),
            aviso: null,
            erros: {},
            categoriesItems: [],
            erpConsultaLoading: false,
            erpConsultaResultado: null,
            erpConsultaErro: null
        }
    }

    componentWillUpdate(nextProps) {
        if ((!this.props.produto && nextProps.produto) || (this.props.produto && nextProps.produto && this.props.produto.updatedAt !== nextProps.produto.updatedAt))
            this.setState(this.generateStateProduto(nextProps));
    }

    searchCategories = (search) => {
        const _searchFormatted = search.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        const _search = this.props.categorias.filter(fiItem => fiItem.nome.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(_searchFormatted))
        this.setState({categoriesItems: _search});
        return console.log(this.state.categoriesItems)
    }

    callbackCategories = (data) => {
        return this.props.updateCategories(data, this.props.produto._id, this.props.usuario.loja, (error) => error && console.log(error));
    }

    validate() {
        const {nome, descricao, categoria, preco} = this.state;
        const erros = {};

        if (!nome) erros.nome = "Preencha aqui com o nome do produto";
        if (!descricao) erros.descricao = "Preencha aqui com a descrição do produto";
        if (!categoria) erros.categoria = "Preencha aqui com a categoria do produto";
        if (!preco) erros.preco = "Preencha aqui com o preço do produto";

        this.setState({erros});
        return !(Object.keys(erros).length > 0);
    }

    updateProduto() {
        const {usuario, produto, updateProduto} = this.props;
        if (!usuario || !produto || !this.validate()) return null;
        updateProduto(this.state, produto._id, usuario.loja, (error) => {
            this.setState({
                aviso: {
                    status: !error,
                    msg: error ? error.message : "Produto atualizado com sucesso!"
                }
            });
        });
    }

    disableProduto = () => {
        const {produto, usuario, updateProduto} = this.props;
        if (!usuario || !produto) return null;
        if (this.state.disponibilidade === "indisponivel") {
            return this.setState({
                aviso: {status: true, msg: "Este produto já está desativado."}
            });
        }
        if (!window.confirm("Deseja desativar este produto? Ele deixará de aparecer na loja, mas permanecerá no sistema.")) {
            return null;
        }
        const payload = {...this.state, disponibilidade: "indisponivel"};
        updateProduto(payload, produto._id, usuario.loja, (error) => {
            this.setState({
                disponibilidade: "indisponivel",
                aviso: {
                    status: !error,
                    msg: error ? error.message : "Produto desativado com sucesso!"
                }
            });
        });
    }

    onChangeInput = (field, value) => this.setState({[field]: value, changes: true});

    consultarERP = async () => {
        const { erpId } = this.state;
        
        if (!erpId) {
            return this.setState({
                aviso: {
                    status: false,
                    msg: "Informe um ID no ERP para consultar"
                }
            });
        }
        
        this.setState({
            erpConsultaLoading: true,
            erpConsultaResultado: null,
            aviso: null
        });
        
        try {
            const resultado = await erpApi.getProdutoByCodigo(erpId);
            
            if (resultado.success) {
                this.setState({
                    erpConsultaResultado: resultado.data,
                    erpConsultaLoading: false,
                    aviso: {
                        status: true,
                        msg: "Produto encontrado no ERP com sucesso!"
                    }
                });
                
                // Auto-preencher campos com dados do ERP
                if (resultado.data && resultado.data.length > 0) {
                    const produtoERP = resultado.data[0];
                    this.setState({
                        nome: produtoERP.nome || this.state.nome,
                        descricao: produtoERP.descricao || this.state.descricao,
                        preco: produtoERP.preco ? formatMoney(produtoERP.preco) : this.state.preco
                    });
                }
            } else {
                this.setState({
                    erpConsultaLoading: false,
                    aviso: {
                        status: false,
                        msg: resultado.error?.message || "Produto não encontrado no ERP ou erro na consulta"
                    }
                });
            }
        } catch (error) {
            this.setState({
                erpConsultaLoading: false,
                aviso: {
                    status: false,
                    msg: `Erro ao consultar ERP: ${error.message}`
                }
            });
        }
    }

    renderDados() {
        const {nome, disponibilidade, quantidade, descricao, categoria, preco, promocao, erpId, erros, erpConsultaLoading} = this.state;
        const {categorias} = this.props;

        if (!categoria || !categorias) return null;

        var _currentCategories = [];
        categorias.filter(fiItem => categoria.map(item => fiItem._id === item && _currentCategories.push(fiItem)))

        return (
            <div>
                <InputSimples label="Nome" error={erros.nome} value={nome}
                              onChange={(e) => this.onChangeInput("nome", e.target.value)}/>

                <TextoDados chave="Disponíbilidade" valor={(
                    <InputSelect nome="disponibilidade" value={disponibilidade} opcoes={[
                        {label: "Disponível", value: "disponivel"},
                        {label: "Indisponível", value: "indisponivel"}
                    ]} onChange={(ev) => this.onChangeInput("disponibilidade", ev.target.value)}/>
                )}/>

                <InputSimples label="Quantidade" error={erros.quantidade} value={quantidade}
                              onChange={(e) => this.onChangeInput("quantidade", e.target.value)}/>

                <SearchCategories data={this.state.categoriesItems || []} currentCategories={_currentCategories || []}
                                  searchAction={(search) => this.searchCategories(search)}
                                  callback={(newData) => this.callbackCategories(newData)}/>

                <TextAreaSimple label="Descrição" error={erros.descricao} value={descricao} row={10} resize="none"
                                onChange={(e) => this.onChangeInput("descricao", e.target.value)}/>

                <InputSimples label="Preco" error={erros.preco} value={preco}
                              onChange={(e) => this.onChangeInput("preco", formatMoneyOnChange(e.target.value))}/>

                <InputSimples label="Valor Promocional" error={erros.promocao} value={promocao}
                              onChange={(e) => this.onChangeInput("promocao", formatMoneyOnChange(e.target.value))}/>

                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                    <div style={{ 
                        backgroundColor: erpId ? '#e6f7ed' : '#fff3e0', 
                        padding: '10px', 
                        borderRadius: '4px', 
                        marginBottom: '10px',
                        border: erpId ? '1px solid #a3d8b5' : '1px solid #ffe0b2'
                    }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginBottom: '5px',
                            color: erpId ? '#2e7d32' : '#e65100'
                        }}>
                            <i className={erpId ? "fas fa-check-circle" : "fas fa-exclamation-triangle"} 
                               style={{ marginRight: '8px' }}></i>
                            <strong>{erpId ? "Integração com ERP configurada" : "Atenção! Produto sem integração com ERP"}</strong>
                        </div>
                        <p style={{ fontSize: '12px', margin: '0' }}>
                            {erpId 
                                ? "Este produto está corretamente configurado para integração com o ERP." 
                                : "Produtos sem ID no ERP não poderão ser integrados automaticamente nas vendas."}
                        </p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                        <div style={{ flex: 1 }}>
                            <InputSimples 
                                label="ID no ERP" 
                                error={erros.erpId} 
                                value={erpId}
                                onChange={(e) => this.onChangeInput("erpId", e.target.value)}
                                style={{ 
                                    borderColor: erpId ? '#a3d8b5' : '#ffe0b2',
                                    backgroundColor: erpId ? '#f5fff9' : '#fffaf0'
                                }}
                            />
                        </div>
                        <div style={{ marginTop: '40px' }}>
                            <button 
                                onClick={this.consultarERP}
                                disabled={erpConsultaLoading}
                                style={{ 
                                    padding: '6px 12px', 
                                    backgroundColor: '#f0f0f0', 
                                    color: '#333', 
                                    border: '1px solid #ccc', 
                                    borderRadius: '4px',
                                    cursor: erpConsultaLoading ? 'wait' : 'pointer',
                                    fontSize: '13px'
                                }}
                            >
                                {erpConsultaLoading ? 'Consultando...' : 'Consultar'}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderErpConsultaResultado() {
        const { erpConsultaResultado } = this.state;
        
        if (!erpConsultaResultado || erpConsultaResultado.length === 0) return null;
        
        const produto = erpConsultaResultado[0];
        
        return (
            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #e9ecef' }}>
                <h4 style={{ fontSize: '14px', marginBottom: '8px', color: '#28a745' }}>Produto encontrado no ERP</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
                    {produto.codigo && (
                        <div>
                            <strong>Código:</strong> {produto.codigo}
                        </div>
                    )}
                    {produto.nome && (
                        <div>
                            <strong>Nome:</strong> {produto.nome}
                        </div>
                    )}
                    {produto.preco !== undefined && (
                        <div>
                            <strong>Preço:</strong> {formatMoney(produto.preco)}
                        </div>
                    )}
                    {produto.quantidade !== undefined && (
                        <div>
                            <strong>Estoque:</strong> {produto.quantidade}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    onRemove = (id) => {
        const {usuario, produto} = this.props;
        if (!usuario || !produto) return null;

        const {fotos: _fotos} = this.state;
        let removeImageFile = _fotos[id];
        const fotos = _fotos.filter((foto, index) => index !== id);
        if (window.confirm("Você realmente deseja remover esta imagem ("+removeImageFile+")?")) {
            this.props.removeProdutoImagens(fotos, removeImageFile, produto._id, usuario.loja, (error) => {
                this.setState({
                    aviso: {
                        status: !error,
                        msg: error ? error.message : "Foto do produto removida com sucesso!"
                    }
                });
            });
        }
    }

    handleUploadFoto = (ev) => {
        const {usuario, produto} = this.props;
        if (!usuario || !produto) return null;

        const data = new FormData();
        data.append("files", ev.target.files[0]);

        this.props.updateProdutoImagens(data, produto._id, usuario.loja, (error) => {
            this.setState({
                aviso: {
                    status: !error,
                    msg: error ? error.message : "Fotos do produto atualizadas com sucesso!"
                }
            });
        });
    }

    renderImagens() {
        const {fotos} = this.state;
        return <BlocoImagens imagens={(fotos || [])} handleSubmit={this.handleUploadFoto} onRemove={this.onRemove}/>
    }

    render() {
        if (!this.props.produto) return null;
        return (
            <>
                <div className="head">
                    <Voltar history={this.props.history} historyPath={"/produtos/"}/>
                    {this.state.disponibilidade === "disponivel" && (
                        <ButtonToolbar type="orange" label="Desativar produto" icon="fas fa-ban"
                                       onClick={() => this.disableProduto()}/>
                    )}
                </div>
                <div className="content">
                    <div className="Page-Title"
                         style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Titulo tipo="h1" titulo={this.props.produto.titulo}/>
                        <div className="ButtonSubmit">
                            <button onClick={() => this.updateProduto()}>Salvar</button>
                        </div>
                        <AlertGeral aviso={this.state.aviso}/>
                    </div>
                    {this.renderDados()}
                    {this.renderErpConsultaResultado()}
                    {this.renderImagens()}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    produto: state.produto.produto,
    categorias: state.categoria.categorias,
    usuario: state.auth.usuario
});

export default connect(mapStateToProps, actions)(DetalhesDoProduto);